import { render, staticRenderFns } from "./CCardErrors.vue?vue&type=template&id=0ea9a1d8&"
import script from "./CCardErrors.vue?vue&type=script&lang=js&"
export * from "./CCardErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports